import { Button } from 'primsell-shared-layer/components'

import { StyledLink, StyledTypography } from 'primsell-shared-layer/components/molecules/agreed-form/agreed-form.styles'
import * as S from './burn-form.styles'
import { useBurnFormController } from './burn-form.controller'
import { IBurnFormProps } from './burn-form.types'

const BurnForm = ({ actionText, ...props }: IBurnFormProps): JSX.Element => {
  const { formik, isFormDisabled } = useBurnFormController(props)

  return (
    <form onSubmit={formik.handleSubmit}>
      <S.Input
        name="email"
        label="Email"
        placeholder="Your Email"
        value={formik.values.email}
        onChange={formik.handleChange}
        isRequired
        error={formik.errors.email}
        disabled={isFormDisabled}
      />
      <S.Input
        name="firstName"
        label="First Name"
        placeholder="Enter your name"
        value={formik.values.firstName}
        onChange={formik.handleChange}
        isRequired
        error={formik.errors.firstName}
        disabled={isFormDisabled}
      />
      <S.Input
        name="lastName"
        label="Last Name"
        placeholder="Enter your last name"
        value={formik.values.lastName}
        onChange={formik.handleChange}
        isRequired
        error={formik.errors.lastName}
        disabled={isFormDisabled}
      />
      <S.AgreedForm
        name="agree"
        onChange={formik.handleChange}
        checked={formik.values.agree}
        error={formik.errors.agree}
        contentText={
          <StyledTypography variant="h5" color="grey">
            By clicking <strong>{actionText}</strong> you agree to{' '}
            <StyledLink to={'https://docs.google.com/document/d/17LurkxjfJsh5yIjKbolm5d93kIVW67wDVlqYAf-1eg8'}>
              Terms and Conditions
            </StyledLink>
            {', '}
            <StyledLink to={'https://docs.google.com/document/d/1Y8Xbe-lzIAc1ohWgwGOddU2rFFcv96DnoaMrF29PG3U'}>
              Privacy policy
            </StyledLink>
          </StyledTypography>
        }
      />
      <Button fullWidth color="dark" variant="filled" type="submit" disabled={isFormDisabled || !formik.values.agree}>
        {actionText}
      </Button>
    </form>
  )
}

export { BurnForm }
